import { IEPGServiceToya } from '@/shared/types/services/types/epgService/epgServiceInterfaces'
import { IEPGServiceStreamIQ } from '@/shared/types/services/types/epgService/IEPGServiceStreamIQ'
import { isStreamIQ, isToya } from '@/shared/lib'

export const getEpgService = async () => {
    if (isToya()) {
        try {
            const module =
                await require('@/clients/toya/services/containers/EPGService/EPGServiceToya')

            return module.default as IEPGServiceToya
        } catch (error) {
            console.warn(
                'useEPGToyaRepository module is missing. TOYA-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/streamiq/services/containers/EPGServiceStreamIQ/EPGServiceStreamIQ')

            return module.default as IEPGServiceStreamIQ
        } catch (error) {
            console.warn(
                'useEPGToyaRepository module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
